/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase'
], (_, UpgradeBase) => {

	/**
	* Upgrade fredIsRed prop, set the value to false for upgraded prop.
	**/

	class FredIsRedUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1017;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}

			this._fredIsRedUpgrade(spec);
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_fredIsRedUpgrade(spec) {
			// some old spec does not have properties
			if (!spec.properties) {
				spec.properties = {};
			}
			spec.properties['fredIsRed'] = false;
		}

	}

	return new FredIsRedUpgrade();
});
